import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Chip from "../../../UI/Chip/Chip";
import ProfilePicture from "../ProfilePicture/ProfilePicture";
const PersonChip = ({ person, className, }) => {
    return (_jsx(Chip, { className: className, picture: (size) => (_jsx(ProfilePicture, { person: person, showProfilePicture: true, size: size })), dropdown: {
            buttonSrText: person.fullName,
            content: (_jsx("div", { className: "media align-items-center px-2 py-1", children: _jsxs(_Fragment, { children: [_jsx(ProfilePicture, { person: person, showProfilePicture: true, size: "sm" }), _jsx("div", { className: "media-body ml-2 d-flex flex-column justify-content-center", children: person.fullName })] }) })),
        }, children: person.fullName }));
};
export default PersonChip;
